import { FC } from 'react';
import { Box, IconButton } from '@mui/material';
import { addDays, addMonths, addWeeks } from 'date-fns';
import { Views } from 'react-big-calendar';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
interface IDateArrows {
  date: Date;
  handleNavigate: (newDate: Date) => void;
  view: string;
}

const enum directions {
  NEXT,
  PREVIOUS
}

export const DateArrows: FC<IDateArrows> = ({ date, handleNavigate, view, children }) => {
  const navigate = (date: Date, direction: directions) => {
    switch (view) {
      case Views.MONTH:
        if (direction === directions.NEXT) {
          handleNavigate(addMonths(date, 1));
        } else {
          handleNavigate(addMonths(date, -1));
        }
        break;
      case Views.WEEK:
      case Views.WORK_WEEK:
        if (direction === directions.NEXT) {
          handleNavigate(addWeeks(date, 1));
        } else {
          handleNavigate(addWeeks(date, -1));
        }
        break;
      case Views.DAY:
        if (direction === directions.NEXT) {
          handleNavigate(addDays(date, 1));
        } else {
          handleNavigate(addDays(date, -1));
        }
        break;
      default:
        break;
    }
  };

  return (
    <Box display="flex" alignItems="center" width="100%">
      <IconButton onClick={() => navigate(date, directions.PREVIOUS)} sx={{ flexShrink: 0, padding: '.75rem 0 .25rem 0' }}>
        <ChevronLeft sx={{ color: theme => theme.palette.common.white }} />
      </IconButton>
      <Box flexGrow={1} display="flex" justifyContent="center" sx={{ minWidth: 0 }}>
        {children}
      </Box>
      <IconButton onClick={() => navigate(date, directions.NEXT)} sx={{ flexShrink: 0, padding: '.75rem 0 .25rem 0'}}>
        <ChevronRight sx={{ color: theme => theme.palette.common.white }} />
      </IconButton>
    </Box>
  );
};
